import type { Location } from "@/types";

const STORAGE_KEY = "plantita_onboarding_complete";

/** Returns whether onboarding was explicitly marked done for this user. */
export function isOnboardingComplete(userId: string): boolean {
  try {
    return localStorage.getItem(`${STORAGE_KEY}_${userId}`) === "1";
  } catch {
    return false;
  }
}

/** Persists onboarding completion for this user in localStorage. */
export function markOnboardingComplete(userId: string): void {
  try {
    localStorage.setItem(`${STORAGE_KEY}_${userId}`, "1");
  } catch {
    // Storage may be unavailable in private mode — onboarding may reappear once.
  }
}

/** Minimal pot shape for inferring whether a garden is already established. */
type PotWithPlants = Readonly<{ plants: readonly unknown[] }>;

/**
 * Whether a signed-in user should see the post-signup onboarding wizard.
 * Legacy gardens with location and at least one plant are auto-marked complete.
 */
export function needsOnboarding(
  userId: string,
  gardenLocation: Location | null,
  pots: readonly PotWithPlants[],
): boolean {
  if (isOnboardingComplete(userId)) return false;
  if (gardenLocation && pots.some((p) => p.plants.length > 0)) {
    markOnboardingComplete(userId);
    return false;
  }
  return true;
}
